<template lang="pug">
.addManagerInputsTable
  BasicInfoInputItem.addManagerInputsTable__item(
    :title="'新增人員姓名*'"
    v-model="name")
  BasicInfoInputItem.addManagerInputsTable__item(
    :title="'所屬單位*'"
    v-model="department")
  BasicInfoInputItem.addManagerInputsTable__item(
    :title="'聯絡電話'"
    v-model="phone")
  BasicInfoInputItem.addManagerInputsTable__item(
    :title="'Email'"
    v-model="email")
  PositionSelector.addManagerInputsTable__item(
    @change="handlePositionChanged")
  BasicInfoInputItem.addManagerInputsTable__item(
    :title="'客服中心電話*'"
    :disabled="true"
    v-model="servicePhone")
  BasicInfoInputItem.addManagerInputsTable__item(
    :title="'客服人員編號*'"
    v-model="serviceNumber")
  BasicInfoInputItem.addManagerInputsTable__item(
    :title="'登入帳號*'"
    v-model="account"
    :hint="'* 20個字以內，不可含空白'"
  )
  BasicInfoInputItem.addManagerInputsTable__item(
    :type="'password'"
    :title="'登入密碼*'"
    v-model="password")
  BasicInfoInputItem.addManagerInputsTable__item(
    :type="'password'"
    :title="'確認密碼*'"
    v-model="confirmedPassword")
  BasicInfoInputItem.addManagerInputsTable__item(
    :title="'備註'"
    v-model="note")
  .addManagerInputsTable__item.container
    BaseButton.addManagerInputsTable__button.col-md-2.col-md-offset-2(
      :text="'職位管理'"
      @click="goAbilityManagement")
    BaseButton.addManagerInputsTable__button.col-md-2(
      :text="'送出'"
      @click="postNewManager")
</template>
<script>
import BasicInfoInputItem from '@/components/common/input/BasicInfoInputItem'
import PositionSelector from '@/pages/manager/PositionSelector'
import BaseButton from '@/components/common/button/BaseButton'
import { mapActions, mapGetters } from 'vuex'
import managerService from '@/API/managerService'
import { cookies } from '@/utils/cookies'

export default {
  data() {
    return {
      name: '',
      department: '',
      phone: '',
      email: '',
      servicePhone: cookies.get('GladCompanyServicePhone'),
      serviceNumber: '',
      account: '',
      password: '',
      confirmedPassword: '',
      note: '',
    }
  },
  computed: {
    ...mapGetters({
      currentPositionId: 'positionStore/getSelectedPositionId',
    }),
  },
  methods: {
    ...mapActions({
      setSelectedPositionById: 'positionStore/setSelectedPositionById',
    }),
    goAbilityManagement() {
      this.$router.push({ name: 'AbilityManagement' })
    },
    handlePositionChanged(id) {
      this.setSelectedPositionById(id)
    },
    checkNameValid() {
      if (this.name === '') {
        alert('請輸入人員姓名')
        return false
      } else if (this.name.length > 20) {
        alert('輸入人員姓名不得超過二十個字')
        return false
      }
      return true
    },
    checkDepartmentValid() {
      if (this.department === '') {
        alert('請輸入所屬單位')
        return false
      } else if (this.department.length > 20) {
        alert('所屬單位不得超過二十個字')
        return false
      }
      return true
    },
    checkServicePhoneValid() {
      if (this.servicePhone === '') {
        alert('請輸入客服中心電話')
        return false
      } else if (this.servicePhone.length > 20) {
        alert('客服中心電話不得超過二十個字')
        return false
      }
      return true
    },
    checkServiceNumberValid() {
      if (this.serviceNumber === '') {
        alert('請輸入客服人員編號')
        return false
      } else if (this.serviceNumber.length > 11) {
        alert('客服人員編號不得超過十一個字')
        return false
      }
      return true
    },
    checkAccountValid() {
      if (this.account === '') {
        alert('請輸入登入帳號')
        return false
      } else if (this.account.length > 20) {
        alert('登入帳號不得超過二十個字')
        return false
      }
      return true
    },
    checkPasswordValid() {
      if (this.password === '') {
        alert('請輸入登入密碼')
        return false
      } else if (this.department.length > 20) {
        alert('登入密碼不得超過二十個字')
        return false
      }
      return true
    },
    checkConfirmedPasswordValid() {
      if (this.confirmedPassword === '') {
        alert('請輸入確認密碼')
        return false
      }
      return true
    },
    checkPasswordConfirmedValid() {
      if (this.confirmedPassword !== this.password) {
        alert('登入密碼與確認密碼不符')
        return false
      }
      return true
    },
    checkRequiredItemsValid() {
      return (
        this.checkNameValid() &&
        this.checkDepartmentValid() &&
        this.checkServicePhoneValid() &&
        this.checkServiceNumberValid() &&
        this.checkAccountValid() &&
        this.checkPasswordValid() &&
        this.checkConfirmedPasswordValid() &&
        this.checkPasswordConfirmedValid()
      )
    },
    async postNewManager() {
      if (this.checkRequiredItemsValid() === false) return
      await managerService
        .addNewManager({
          name: this.name,
          department: this.department,
          phone: this.phone,
          email: this.email,
          servicePhone: this.servicePhone,
          serviceNumber: this.serviceNumber,
          account: this.account.trim(),
          password: this.password,
          confirmedPassword: this.confirmedPassword,
          note: this.note,
          positionId: this.currentPositionId,
        })
        .then(() => {
          alert('新增人員成功')
          this.$router.push({ name: 'ManagerList' })
        })
        .catch((err) => {
          const { result } = err.data
          alert(`新增人員失敗 ${result}`)
        })
    },
  },
  components: {
    BasicInfoInputItem,
    PositionSelector,
    BaseButton,
  },
}
</script>
<style lang="scss" scoped>
.addManagerInputsTable {
  padding: 15px 0;

  &__item {
    margin-top: 10px;

    &:first-child {
      margin-top: 0;
    }
  }

  &__button {
    height: 37px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/AddManagerInputsTable.vue